import { generateSeoProps } from '../generateSeoProps';
export const getLecturesSeoProps = ({ title = '', description = '', id = '', slug = '' }) => {
	return generateSeoProps({
		title: `${title} - Pharmuni Course`,
		description: description,
		canonical: `courses/${id}/${slug}`,
		noIndex: false
	});
};
